module.exports = __webpack_public_path__ + "img/res.23026a63.png";